import axios from "axios";

export default async function fetchTermOfUseData() {
  const url = `${process.env.NEXT_PUBLIC_TERM_OF_USE_CDN}?q=${new Date().getTime()}`;
  let result = null;
  const res = await axios({
    method: "get",
    url: url,
  });
  if (res.status === 200) {
    result = res.data;
    console.log("🚀 ~ fetchTermOfUseData ~ result:", result)
  }
  return result;
}
